import { render, staticRenderFns } from "./AuthSharedForm.vue?vue&type=template&id=cbf47e66&scoped=true&"
import script from "./AuthSharedForm.vue?vue&type=script&lang=js&"
export * from "./AuthSharedForm.vue?vue&type=script&lang=js&"
import style0 from "./AuthSharedForm.vue?vue&type=style&index=0&id=cbf47e66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf47e66",
  null
  
)

export default component.exports